let CancelToken;
let source;

const Config = require('~/config/default.env').default;

export default {
  namespaced: true,
  state: {
    product: [],
    loading: true,
    total_product: 0,
    brand: {
      data: '',
      loading: true,
    },
    categories: [],
    popular_review: {
      data: '',
      loading: '',
    },
  },
  mutations: {
    SET_LOAD_PRODUCT(state, data) {
      state.loading = data;
    },
    SET_DATA_BRAND(state, data) {
      state.brand.data = data;
    },
    SET_PRODUCT(state, data) {
      state.product = data;
    },
    SET_LOAD_BRAND(state, data) {
      state.brand.loading = data;
    },
    SET_TOTAL_PRODUCT(state, data) {
      state.total_product = data;
    },
    SET_CATEGORIES(state, data) {
      state.categories = data;
    },
    SET_POPULAR_REVIEW(state, data) {
      state.popular_review.data = data;
    },
    SET_LOAD_POPULAR_REVIEW(state, data) {
      state.popular_review.loading = data;
    },
    MERGE_PRODUCT(state, data) {
      state.product = state.product.concat(data);
    },
  },
  actions: {
    async getBrands({ state, dispatch, commit }, brandId) {
      const filter = {
        my_soco_sql_id: brandId,
      };
      commit('SET_LOAD_BRAND', true);
      return new Promise((resolve, reject) => {
        try {
          resolve(
            this._vm.$MS_SOCO_PUBLIC_API_URL.get('/brands', {
              params: {
                filter,
                limit: 1,
              },
            })
          );
        } catch (error) {
          reject(error);
        }
      })
        .then(({ data }) => {
          const datas = data.data[0];
          commit('SET_DATA_BRAND', datas);
          dispatch('getDistinctCategories', datas.slug);
          dispatch('getPopularReview', datas._id);
          dispatch('getProductsTotal', datas.slug);
        })
        .catch((err) => {
          commit('SET_DATA_BRAND', '');
        })
        .finally(() => {
          commit('SET_LOAD_BRAND', false);
        });
    },
    getProductsTotal({ commit, state, dispatch, rootState, rootGetters }, brandId) {
      if (typeof source !== 'undefined') {
        source.cancel(false);
      }
      CancelToken = axios.CancelToken;
      source = CancelToken.source();
      const filter = {
        is_deleted: false,
      };
      if (state.brand.data.slug) {
        filter['brand.slug'] = state.brand.data.slug;
      } else if (!state.brand.data.slug) {
        filter['brand.my_soco_sql_id'] = state.brand.data.my_soco_sql_id;
      }

      const params = {
        filter,
        section: 'getProductsTotal',
      };

      if (rootState.$_Review.queryString.sort) {
        params.sort = rootState.$_Review.queryString.sort;
      }

      if (rootState.$_Review.queryString.brands) {
        params.filter['brand.id'] = {
          $in: rootState.$_Review.queryString.brands.split(','),
        };
      }

      if (rootState.$_Review.queryString.tags) {
        params.filter['tags.id'] = {
          $in: rootState.$_Review.queryString.tags.split(','),
        };
      }

      if (rootState.$_Review.queryString.origins) {
        params.filter['brand.country_tag_id'] = {
          $in: rootState.$_Review.queryString.origins.split(','),
        };
      }

      if (rootState.$_Review.queryString.category) {
        params.filter['categories.id'] = {
          $in: rootState.$_Review.queryString.category,
        };
      }

      if (rootState.$_Review.queryString.available_for) {
        if (
          rootState.$_Review.queryString.available_for.includes('sociolla') &&
          rootState.$_Review.queryString.available_for.includes('lulla')
        ) {
          params.filter['is_active_in_sociolla'] = true;
          params.filter['is_active_in_lulla'] = true;
        } else if (rootState.$_Review.queryString.available_for.includes('lulla')) {
          params.filter['is_active_in_lulla'] = true;
          params.filter['is_active_in_sociolla'] = false;
        } else {
          params.filter['is_active_in_sociolla'] = true;
          params.filter['is_active_in_lulla'] = false;
        }
      }

      if (rootState.$_Review.queryString.rating) {
        const filterQuery = rootState.$_Review.queryString.rating.split(',') || [];
        filterQuery.map((x) => {
          const intRating = Number(x);
          params.filter['review_stats.average_rating'] = {
            $gte: intRating,
            $lte: intRating + 0.999,
          };
        });
      }
      const paramSearch = { params: params, cancelToken: source.token };
      return axios
        .get(`${Config.MS_CATALOG_API_URL}/search/count`, paramSearch)
        .then((response) => {
          const datas = response.data.data;
          const slugBrand = state.brand.data.slug;
          commit('SET_TOTAL_PRODUCT', datas);
          if (datas > 0) {
            dispatch('getProducts', slugBrand);
          } else {
            commit('SET_PRODUCT', []);
            commit('SET_LOAD_PRODUCT', false);
          }
        })
        .catch((err) => {
          commit('SET_TOTAL_PRODUCT', 0);
        });
    },
    getProducts({ commit, state, dispatch, rootState, rootGetters }, brandId) {
      if (typeof source !== 'undefined') {
        source.cancel(false);
      }
      CancelToken = axios.CancelToken;
      source = CancelToken.source();
      // eslint-disable-next-line vue/require-prop-types
      const filter = {
        is_deleted: false,
      };
      if (state.brand.data.slug) {
        filter['brand.slug'] = state.brand.data.slug;
      } else if (!state.brand.data.slug) {
        filter['brand.my_soco_sql_id'] = state.brand.data.my_soco_sql_id;
      }

      const params = {
        filter,
        limit: rootState.$_Review.queryString.limit,
        skip: rootState.$_Review.queryString.skip,
        sort: '-review_stats.total_reviews',
      };

      if (rootState.$_Review.queryString.sort) {
        params.sort = rootState.$_Review.queryString.sort;
      }

      if (rootState.$_Review.queryString.brands) {
        params.filter['brand.id'] = {
          $in: rootState.$_Review.queryString.brands.split(','),
        };
      }
      if (rootState.$_Review.queryString.tags) {
        params.filter['tags.id'] = {
          $in: rootState.$_Review.queryString.tags.split(','),
        };
      }

      if (rootState.$_Review.queryString.origins) {
        params.filter['brand.country_tag_id'] = {
          $in: rootState.$_Review.queryString.origins.split(','),
        };
      }

      if (rootState.$_Review.queryString.category) {
        params.filter['categories.id'] = {
          $in: rootState.$_Review.queryString.category,
        };
      }

      if (rootState.$_Review.queryString.rating) {
        const filterQuery = rootState.$_Review.queryString.rating.split(',') || [];
        filterQuery.map((x) => {
          const intRating = Number(x);
          params.filter['review_stats.average_rating'] = {
            $gte: intRating,
            $lte: intRating + 0.999,
          };
        });
      }

      if (rootState.$_Review.queryString.available_for) {
        if (
          rootState.$_Review.queryString.available_for.includes('sociolla') &&
          rootState.$_Review.queryString.available_for.includes('lulla')
        ) {
          params.filter['is_active_in_sociolla'] = true;
          params.filter['is_active_in_lulla'] = true;
        } else if (rootState.$_Review.queryString.available_for.includes('lulla')) {
          params.filter['is_active_in_lulla'] = true;
          params.filter['is_active_in_sociolla'] = false;
        } else {
          params.filter['is_active_in_sociolla'] = true;
          params.filter['is_active_in_lulla'] = false;
        }
      }

      const paramSearch = { params: params, cancelToken: source.token };
      return axios
        .get(`${Config.MS_CATALOG_API_URL}/search`, paramSearch)
        .then((response) => {
          if (response.status === 200) {
            const datas = response.data.data;
            commit('SET_PRODUCT', datas);
            commit('SET_LOAD_PRODUCT', false);
          }
        })
        .catch((err) => {
          commit('SET_PRODUCT', []);
          commit('SET_LOAD_PRODUCT', false);
        });
    },
    async getDistinctCategories({ state, dispatch, commit }, keyword) {
      return new Promise((resolve, reject) => {
        try {
          resolve(
            this._vm.$MS_CATALOG_API_URL.get(`/v3/categories/distinct/products`, {
              params: {
                filter: {
                  'brand.slug': keyword,
                  is_children: true,
                },
              },
            })
          );
        } catch (error) {
          reject(error);
        }
      }).then(({ data }) => {
        const results = data.data;
        commit('SET_CATEGORIES', results);
      });
    },
    getPopularReview({ commit, state, dispatch, rootState, rootGetters }, brandId) {
      commit('SET_LOAD_POPULAR_REVIEW', true);
      return axios
        .get(`${Config.MS_REVIEW_API_URL}/reviews/brands/${brandId}/popular/`)
        .then((response) => {
          if (response.status === 200) {
            const datas = response.data.data;
            commit('SET_POPULAR_REVIEW', datas);
          }
        })
        .catch((err) => {
          commit('SET_POPULAR_REVIEW', []);
        })
        .finally(() => {
          commit('SET_LOAD_POPULAR_REVIEW', false);
        });
    },
    loadMoreProducts({ commit, state, dispatch, rootState, rootGetters }, brandId) {
      if (typeof source !== 'undefined') {
        source.cancel(false);
      }
      CancelToken = axios.CancelToken;
      source = CancelToken.source();
      const filter = {
        is_deleted: false,
      };
      if (state.brand.data.slug) {
        filter['brand.slug'] = state.brand.data.slug;
      } else if (!state.brand.data.slug) {
        filter['brand.my_soco_sql_id'] = state.brand.data.my_soco_sql_id;
      }

      const params = {
        filter,
        limit: rootState.$_Review.queryString.limit,
        skip: rootState.$_Review.queryString.skip,
        sort: '-review_stats.total_reviews',
      };

      if (rootState.$_Review.queryString.sort) {
        params.sort = rootState.$_Review.queryString.sort;
      }

      if (rootState.$_Review.queryString.brands) {
        params.filter['brand.id'] = {
          $in: rootState.$_Review.queryString.brands.split(','),
        };
      }

      if (rootState.$_Review.queryString.tags) {
        params.filter['tags.id'] = {
          $in: rootState.$_Review.queryString.tags.split(','),
        };
      }

      if (rootState.$_Review.queryString.origins) {
        params.filter['brand.country_tag_id'] = {
          $in: rootState.$_Review.queryString.origins.split(','),
        };
      }

      if (rootState.$_Review.queryString.category) {
        params.filter['categories.id'] = {
          $in: rootState.$_Review.queryString.category,
        };
      }

      if (rootState.$_Review.queryString.rating) {
        const filterQuery = rootState.$_Review.queryString.rating.split(',') || [];
        const rating = [];
        filterQuery.map((x) => {
          const intRating = Number(x);
          if (filterQuery.length > 1) {
            rating.push({
              'review_stats.average_rating': {
                $gte: intRating,
                $lte: intRating + 0.999,
              },
            });
          } else {
            rating.push({
              'review_stats.average_rating': { $gte: intRating },
            });
            rating.push({
              'review_stats.average_rating': { $lte: intRating + 0.999 },
            });
          }
        });
        if (filterQuery.length > 1) {
          params.filter['$and'] = [{ $or: rating }];
        } else {
          params.filter['$and'] = rating;
        }
      }

      if (rootState.$_Review.queryString.available_for) {
        if (
          rootState.$_Review.queryString.available_for.includes('sociolla') &&
          rootState.$_Review.queryString.available_for.includes('lulla')
        ) {
          params.filter['is_active_in_sociolla'] = true;
          params.filter['is_active_in_lulla'] = true;
        } else if (rootState.$_Review.queryString.available_for.includes('lulla')) {
          params.filter['is_active_in_lulla'] = true;
          params.filter['is_active_in_sociolla'] = false;
        } else {
          params.filter['is_active_in_sociolla'] = true;
          params.filter['is_active_in_lulla'] = false;
        }
      }

      const paramSearch = { params: params, cancelToken: source.token };
      return axios
        .get(`${Config.MS_CATALOG_API_URL}/search`, paramSearch)
        .then((response) => {
          if (response.status === 200) {
            const datas = this._vm.$get(response, 'data.data', []);
            commit('MERGE_PRODUCT', datas);
          } else {
            commit('MERGE_PRODUCT', []);
          }
          return response;
        })
        .catch((err) => {
          commit('MERGE_PRODUCT', []);
          return err;
        });
    },
  },
};
